import {getMinuteForm} from "../main-specialist-video/main-specialist-video";

const DATA_ATTR = 'data-exercise-card';
const CLASS_PREFIX = 'exercise-card';
const template = document.querySelector(`[${DATA_ATTR}-container-template]`);
const taskTemplate = document.querySelector(`[${DATA_ATTR}-task-template]`);

const templateSpecialist = document.querySelector(`[${DATA_ATTR}-specialist-template]`);
const templateSpecialistContainer = document.querySelector(`[${DATA_ATTR}-specialist-container-template]`);

export function initExerciseCard(container, data) {

    init();
    async function init() {
        await renderExercise(data)
    }
    function bindContainerOpen(exerciseContainer) {
        const containerOpenBtns = exerciseContainer.querySelectorAll(`[${DATA_ATTR}-container-open]`);
        const containers = exerciseContainer.querySelectorAll(`[${DATA_ATTR}-container]`);
        containerOpenBtns.forEach(containerOpenBtn => {
            containerOpenBtn.addEventListener('click', (e) => {

                event.stopPropagation();
                const openContainerKey = containerOpenBtn.dataset.exerciseCardContainerOpen

                containers.forEach(currentContainer => {
                    const currentContainerKey = currentContainer.dataset.exerciseCardContainer

                    if (openContainerKey === currentContainerKey) {
                        currentContainer.classList.add('open')
                    } else {
                        currentContainer.classList.remove('open')
                    }
                })

            })
        })
    }

    function renderSpecialistContainer(mainContainer, specialist, key) {
        const clone = document.importNode(templateSpecialistContainer.content, true);
        const currentContainer = clone.querySelector(`[${DATA_ATTR}-container]`);
        const specialistName = clone.querySelector(`[${DATA_ATTR}-name]`);
        const specialistImage = clone.querySelector(`[${DATA_ATTR}-image]`);
        const specialistImageM = clone.querySelector(`[${DATA_ATTR}-image-m]`);
        const specialistExp = clone.querySelector(`[${DATA_ATTR}-exp]`);
        const specialistSpec = clone.querySelector(`[${DATA_ATTR}-spec]`);
        const specialistSupportButton = clone.querySelector(`[${DATA_ATTR}-support-button]`);

        const specialistTagList = clone.querySelector(`[${DATA_ATTR}-tag-list]`);
        const specialistAbout = clone.querySelector(`[${DATA_ATTR}-about]`);
        const specialistAboutMore = clone.querySelector(`[${DATA_ATTR}-about-more]`);

        specialistImage.src = `/storage/specialists/${specialist.id}/${specialist.image}`;
        specialistImageM.src = `/storage/specialists/${specialist.id}/${specialist.image}`;
        specialistName.textContent = specialist.name;
        specialistAbout.innerText = specialist.about;
        if (specialist.experience) {
            specialistExp.innerText = calculateExperience(specialist.experience);
        }
        if (specialist.profession) {
           specialistSpec.innerText = specialist.profession
        }

        specialistSupportButton.dataset.specialistId = specialist.id;


        currentContainer.dataset.exerciseCardContainer = key

        appendSpecialistTags(specialistTagList, specialist);

        mainContainer.appendChild(clone);
    }

    function renderExercise(exercise) {
        if (!exercise) {
            return;
        }
        const clone = document.importNode(template.content, true);

        const mainContainer = clone.querySelector(`[${DATA_ATTR}-main-container]`);

        const imgContainer = clone.querySelector(`[${DATA_ATTR}-image-container]`);
        const imgPreview = clone.querySelector(`[${DATA_ATTR}-image]`);
        const title = clone.querySelector(`[${DATA_ATTR}-title]`);
        const desc = clone.querySelector(`[${DATA_ATTR}-description]`);
        const info = clone.querySelector(`[${DATA_ATTR}-preview-info]`);
        const tagList = clone.querySelector(`[${DATA_ATTR}-tag-list]`);
        const taskList = clone.querySelector(`[${DATA_ATTR}-task-list]`);
        const specialistsList = clone.querySelector(`[${DATA_ATTR}-specialists]`);

        imgPreview.src =  exercise.video_preview_url || null;
        title.textContent = exercise.title;
        title.href = `/exercise/${exercise.id}`
        imgContainer.href = `/exercise/${exercise.id}`
        desc.textContent = exercise.description;
        info.textContent = getMinuteForm(exercise.duration);


        if (exercise.specialist)
        {
            const specClone = document.importNode(templateSpecialist.content, true);
            const specImg = specClone.querySelector(`[${DATA_ATTR}-specialist-img]`);
            const specName = specClone.querySelector(`[${DATA_ATTR}-specialist-name]`);


            specImg.src = `/storage/specialists/${exercise.specialist.id}/${exercise.specialist.image}`;
            specName.textContent = exercise.specialist.name;
            specialistsList.appendChild(specClone);
            renderSpecialistContainer(mainContainer, exercise.specialist, 'specialist')
        }
        if (exercise.supervisor)
        {
            const visorClone = document.importNode(templateSpecialist.content, true);
            const visorItem = visorClone.querySelector(`[${DATA_ATTR}-specialist]`);
            const visorImg = visorClone.querySelector(`[${DATA_ATTR}-specialist-img]`);
            const visorName = visorClone.querySelector(`[${DATA_ATTR}-specialist-name]`);
            const specLabel = visorClone.querySelector(`[${DATA_ATTR}-specialist-label]`);

            visorItem.dataset.exerciseCardContainerOpen = 'supervisor'
            visorImg.src = `/storage/specialists/${exercise.supervisor.id}/${exercise.supervisor.image}`;
            visorName.textContent = exercise.supervisor.name;
            specLabel.textContent = 'Обзор преподавателя';

            specialistsList.appendChild(visorClone);
            renderSpecialistContainer(mainContainer, exercise.supervisor, 'supervisor')
        }


        appendTags(tagList, exercise);
        appendTasks(taskList, exercise.tasks);

        bindContainerOpen(clone);
        container.appendChild(clone);
    }

    function appendSpecialistTags(container, specialist) {
        const fragment = document.createDocumentFragment();

        specialist.tags.forEach(tag => fragment.appendChild(createTag(tag.name, false, 'container-specialist-list-tag')));
        container.appendChild(fragment);
    }
    function appendTags(container, exercise) {
        const fragment = document.createDocumentFragment();
        if (exercise.is_free) {
            fragment.appendChild(createTag('Бесплатно', 'green'));
        }

        if (exercise.serials) {
            exercise.serials.forEach(serial => fragment.appendChild(createTag(`${serial.serial_title}: Серия ${serial.episode_number}/${serial.total_episodes}`, 'black')));
        }

        exercise.tags.forEach(tag => fragment.appendChild(createTag(tag.name)));
        container.appendChild(fragment);
    }

    function createTag(text, highlight = null, tagClass = 'exercise-tags-tag') {
        const tag = document.createElement('div');
        tag.classList.add(`${CLASS_PREFIX}__${tagClass}`);
        if (highlight != null) {
            if (highlight == 'green') {
                tag.classList.add(`${CLASS_PREFIX}__exercise-tags-tag--green`);
            }
            if (highlight == 'black') {
                tag.classList.add(`${CLASS_PREFIX}__exercise-tags-tag--black`);
            }
        }

        tag.textContent = text;
        return tag;
    }

    function appendTasks(container, tasks) {
        const frag = document.createDocumentFragment();
        tasks.forEach(task => {
            const clone = document.importNode(taskTemplate.content, true);
            const link = clone.querySelector(`[${DATA_ATTR}-task-item]`);
            const fill = clone.querySelector(`[${DATA_ATTR}-task-item-fill]`);
            const nameEl = clone.querySelector(`[${DATA_ATTR}-task-item-name]`);
            const icon = clone.querySelector(`[${DATA_ATTR}-task-item-icon]`);
            // Set href
            link.href = `/exercise/${task.video_id}?task=${task.id}`;

            // Set name
            nameEl.textContent = `${task.difficulty?.name || ''}: ${task.type?.name || ''}`;
            // Compute and set progress
            if (task.total_questions > 0) {
                const percent = Math.round((task.answered_questions / task.total_questions) * 100);
                fill.style.width = `${percent}%`;

            }
            if(task.answered_questions > 0){
                link.style.background = '#D1F2D9';
            }
            // If completed, add icon
            if (task.is_completed) {
                icon.style.display = 'flex';
            }
            frag.appendChild(clone);
        });
        container.appendChild(frag);
    }

    function calculateExperience(experienceDate) {
        const years = new Date().getFullYear() - new Date(experienceDate).getFullYear();
        return `Стаж практики: ${years} ${years === 1 ? "год" : years >= 2 && years <= 4 ? "года" : "лет"}`;
    }
}
